var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalificanos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 125,
    height: 36,
    viewBox: "0 0 125 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #00095b;\r\n        font-size: 14px;\r\n        font-family: FordAntenna-Light, Ford Antenna;\r\n        font-weight: 300;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1221",
    "data-name": "Group 1221",
    transform: "translate(-1727 -932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2",
    "data-name": "Polygon 2",
    className: "cls-1",
    d: "M10.5,0,21,18H0Z",
    transform: "translate(1852 939.5) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_537",
    "data-name": "Rectangle 537",
    className: "cls-1",
    width: 116,
    height: 36,
    rx: 7,
    transform: "translate(1727 932)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1220",
    "data-name": "Group 1220",
    transform: "translate(-5198.824 -30)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_Calif\\xEDcanos_",
    "data-name": "\\xA1Calif\\xEDcanos!",
    className: "cls-2",
    transform: "translate(6940.823 985)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xA1Calif\xEDcanos!"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalificanos);
export default __webpack_public_path__ + "static/media/calificanos.33237aa32dfcbc686a748dfd9003ab4b.svg";
export { ForwardRef as ReactComponent };